import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useRankingChallenge = (challengeType) => {
  const localPrefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['rankingChallenge', challengeType],
    queryFn: async () => {
      const result = await restClient({ url: `${localPrefix}/rankings/challenges/${challengeType}` });
      return result;
    },
    enabled: !!challengeType, 
    staleTime: 0,
    cacheTime: 0
  });
};
